import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowBack as ArrowBackIcon } from '@material-ui/icons';
import { IconButton, Typography, Button } from '@material-ui/core';

import { inputFieldNames } from '../../constants';

import ControlsList from './ControlsList';
import calculateNextEventDate from '../../mappers/calculateNextEventDate';
import { submitMode } from '../../constants';
import AddHazardControlDialog from '../../containers/AddHazardControlDialog';

const useStyles = makeStyles((theme) => ({
  simpleLabel: {
    display: 'inline-block',
    marginTop: 2
  },
  editHazardFieldsContainer: {
    padding: theme.spacing(2)
  },
  backArrow: {
    marginLeft: -16
  },
  courseName: {
    fontWeight: 600
  },
  addControlButton: {
    marginTop: 8
  }
}));

const EditHazardPanel = (props) => {
  const {
    hazard,
    openEditHazardPanel,
    fetchControlsForTheHazard,
    controls,
    submitControl,
    enableEditHazardControl,
    isEditControlEnabled,
    controlBeingEdited,
    onHandleEditHazardControlInputChange,
    onOpenAddHazardControlDialog,
    openAddHazardControlDialog,
    showDeleteHazardControlDialog,
    onOpenDeleteControlDialog,
    branchId,
    userId,
    openDocumentListDialog
  } = props;
  const classes = useStyles();

  React.useEffect(
    () => {
      fetchControlsForTheHazard(hazard.id);
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [hazard.id]
  );

  const handleEditHazardControlInputChange = (e, inputfieldName) => {
    if (
      inputfieldName === inputFieldNames.RECORD_DATE ||
      inputfieldName === inputFieldNames.HAZARD_CONTROL_DOCUMENT
    ) {
      onHandleEditHazardControlInputChange(e, inputfieldName);
    } else {
      onHandleEditHazardControlInputChange(e.target.value, inputfieldName);
    }
  };

  const handleSaveHazardControlClick = (e) => {
    e.preventDefault();

    const payload = {
      hazardId: hazard.id,
      ...controlBeingEdited
    };

    submitControl(payload, submitMode.UPDATE, branchId);
  };

  const handleOpenDeleteHazardControlClick = (open, controlId) => {
    onOpenDeleteControlDialog(open, controlId);
  };


  return (
    <React.Fragment>
      {openAddHazardControlDialog ? <AddHazardControlDialog /> : null}

      <div className={classes.backArrowContainer}>
        <IconButton
          aria-label="show 4 new mails"
          color="inherit"
          onClick={() => openEditHazardPanel(false)}
          id="settings-button"
          className={classes.backArrow}
        >
          <ArrowBackIcon color="primary" />
        </IconButton>
        <Typography className={classes.simpleLabel}>Hazards</Typography>
      </div>

      <div className={classes.courseNameContainer}>
        <Typography className={classes.courseName}>
          {hazard.description}
        </Typography>
      </div>

      <Button
        color="primary"
        variant="contained"
        className={classes.addControlButton}
        onClick={() => onOpenAddHazardControlDialog(true)}
      >
        Add Control
      </Button>

      <ControlsList
        controls={controls}
        enableEditHazardControl={enableEditHazardControl}
        userId={userId}
        isEditControlEnabled={isEditControlEnabled}
        controlBeingEdited={controlBeingEdited}
        handleEditHazardControlInputChange={handleEditHazardControlInputChange}
        handleSaveHazardControlClick={handleSaveHazardControlClick}
        showDeleteControlDialog={showDeleteHazardControlDialog}
        handleOpenDeleteHazardControlClick={handleOpenDeleteHazardControlClick}
        openDocumentListDialog={openDocumentListDialog}
      />
    </React.Fragment>
  );
};

export default EditHazardPanel;
